$shm_projects_tests $shm_tests_app
	project_id \
